"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.setLanguage = setLanguage;
exports.translate = translate;
var _services = require("@onviobr/services");
var _enAu = _interopRequireDefault(require("./en-au"));
var _enCa = _interopRequireDefault(require("./en-ca"));
var _enGb = _interopRequireDefault(require("./en-gb"));
var _enIn = _interopRequireDefault(require("./en-in"));
var _enUs = _interopRequireDefault(require("./en-us"));
var _esAr = _interopRequireDefault(require("./es-ar"));
var _frCa = _interopRequireDefault(require("./fr-ca"));
var _nlNl = _interopRequireDefault(require("./nl-nl"));
var _ptBr = _interopRequireDefault(require("./pt-br"));
var currentLang;
function setLanguage(id) {
  currentLang = id || 'en-US';
}
function translate(key) {
  currentLang = currentLang || _services.i18n.getCurrentLanguage();
  switch (currentLang) {
    case 'en-AU':
      {
        return _enAu.default[key] || _enUs.default[key];
      }
    case 'en-CA':
      {
        return _enCa.default[key] || _enUs.default[key];
      }
    case 'en-GB':
      {
        return _enGb.default[key] || _enUs.default[key];
      }
    case 'en-IN':
      {
        return _enIn.default[key] || _enUs.default[key];
      }
    case 'en-US':
      {
        return _enUs.default[key] || _enUs.default[key];
      }
    case 'es-AR':
      {
        return _esAr.default[key] || _enUs.default[key];
      }
    case 'fr-CA':
      {
        return _frCa.default[key] || _enUs.default[key];
      }
    case 'nl-NL':
      {
        return _nlNl.default[key] || _enUs.default[key];
      }
    case 'pt-BR':
      {
        return _ptBr.default[key] || _enUs.default[key];
      }
    default:
      {
        return _enUs.default[key];
      }
  }
}
